import { Notifier } from '@airbrake/browser';


window.airbrake = {
  notify: (error) => console.error(error)
};

